import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button, FormFeedback } from "reactstrap";
import { useParams } from "react-router-dom";
import UserServices from "../services/UserServices";

const ResetPassword = () => {
    const { token } = useParams();
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const [passwordsMatch, setPasswordsMatch] = useState(true);

    const isPasswordValid = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return regex.test(password);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        if (e.target.value !== passwordConfirmation) {
            setPasswordsMatch(false);
        } else {
            setPasswordsMatch(true);
        }
    };

    const handlePasswordConfirmationChange = (e) => {
        setPasswordConfirmation(e.target.value);
        if (e.target.value !== password) {
            setPasswordsMatch(false);
        } else {
            setPasswordsMatch(true);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isPasswordValid(password)) {
            setMessage("");
            setAlert("Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un nombre, un caractère spécial et avoir une longueur minimale de 8 caractères.");
            return;
        }
        
        const user = {
            token: token,
            password: password,
            password_confirmation: passwordConfirmation
        };
        UserServices
            .ResetPassword(user)
            .then(data => {
                console.log(data);
                if (data['success'] === true) {
                    setPassword('');
                    setPasswordConfirmation('');
                    setPasswordsMatch(true);
                    setAlert("");
                    setMessage("Le mot de passe a été changé avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    return (
        <div className="container">
            <div className="row">

                {message && <div className="alert alert-success mt-1">{message}</div>}
                {alert && <div className="alert alert-danger mt-1">{alert}</div>}
                <div className="col-md-4"></div>
                <div className="col-md-4">
                    <h3 className="text-center mb-3">Réinitialiser le mot de passe</h3>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label for="password">Nouveau mot de passe</Label>
                            <Input
                                type="password"
                                name="password"
                                id="password"
                                placeholder="Entrez un nouveau mot de passe (8 caractères au minimum)"
                                value={password}
                                onChange={handlePasswordChange}
                                required={true}
                                invalid={!passwordsMatch}
                            />
                            {!passwordsMatch && <FormFeedback>Les mots de passe ne correspondent pas</FormFeedback>}
                        </FormGroup>
                        <FormGroup>
                            <Label for="passwordConfirmation">Confirmer le nouveau mot de passe</Label>
                            <Input
                                type="password"
                                name="passwordConfirmation"
                                id="passwordConfirmation"
                                placeholder="Confirmez le nouveau mot de passe"
                                value={passwordConfirmation}
                                onChange={handlePasswordConfirmationChange}
                                required={true}
                                invalid={!passwordsMatch}
                            />
                            {!passwordsMatch && <FormFeedback>Les mots de passe ne correspondent pas</FormFeedback>}
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Enregistrer le nouveau mot de passe
                        </Button>
                    </Form>
                </div>
                <div className="col-md-4"></div>
            </div>
        </div>
    );
};

export default ResetPassword;
